import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await axios.post(
          `${BACKEND_URL}/api/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        if (setUser) setUser(data);
        toast.success(`Welcome, ${data.name?.split(' ')[0] || 'friend'}!`);
        // Strip hash + send user home
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/', { replace: true, state: { user: data } });
      } catch (err) {
        toast.error(err.response?.data?.detail || 'Google sign-in failed');
        navigate('/login', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]" data-testid="auth-callback-page">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#C27054] mx-auto mb-4"></div>
        <p className="text-[#7A8A73]">Signing you in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
